import PeriodEditor from './PeriodEditor.vue'
export default {
  install: function (Vue) {
    Vue.component('period-editor', PeriodEditor)
  }
}